module.exports = __webpack_public_path__ + "img/smiley.0df2ce6c.svg";